import {
  COMMON,
  faqTranslation,
  translationUrl,
  VDS_KEY,
  VERSION,
} from "../../constants/ApiUrls";
import { getData } from "../../networkManager/NetworkManager";

export const getFAQ = async () => {
  return await getData(VDS_KEY + VERSION + `${faqTranslation.FAQ}`);
};
